import { useEffect } from "react";
import { useGetIdentity } from "ra-core";
import { useQueryClient } from "@tanstack/react-query";
import { getSupabaseClient } from "@/components/atomic-crm/providers/supabase/supabase";
import { sharedResources, subscribeToWorkspace } from "./realtime";

export const NarsRealtime = () => {
  const { identity } = useGetIdentity();
  const queryClient = useQueryClient();
  useEffect(() => {
    if (identity?.id == null) return;
    return subscribeToWorkspace(getSupabaseClient(), () => {
      void queryClient.invalidateQueries({
        predicate: (query) =>
          sharedResources.includes(
            query.queryKey[0] as (typeof sharedResources)[number],
          ),
      });
    });
  }, [identity?.id, queryClient]);
  return null;
};
